import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { ChangePayCurentYearMonthComponent } from "../../change-pay-curent-year-month/change-pay-curent-year-month.component";
import { HrmPayCurentYearMonthComponent } from "../../hrm-pay-curent-year-month/hrm-pay-curent-year-month.component";
import { ElementGroup } from "../../models/enums/element-group";
import { HRNotificationHeader } from "../../models/hrnotification-header.model";
import { EstablishmentTheReserveOfYearsOfServiceFormComponent } from "../establishment-the-reserve-of-years-of-service-form/establishment-the-reserve-of-years-of-service-form.component";
import { RewardPaymentEffectWorkFormComponent } from "../reward-payment-effect-work-form/reward-payment-effect-work-form.component";
import { VacationBuyInformationFormComponent } from "../vacation-buy-Information-form/vacation-buy-Information-form.component";

@Component({
  selector: "ngx-monthly-salary-calculation-information",
  templateUrl: "./monthly-salary-calculation-information.component.html",
  styleUrls: ["./monthly-salary-calculation-information.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthlySalaryCalculationInformationComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: { name: string };
  actions: EntityListAction[];
  filterInfo: NameValue[] = [];
  @ViewChild(KGridComponent)
  public grid: KGridComponent;
  constructor(
    private tabsservice: TabularService,
    private cd: ChangeDetectorRef,
    private _VoucherKindInfo: VoucherKindInfo,
    private splashFormService: SplashFormService
  ) {
    super();
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "MonthlySalaryCalculationInformation/HRNotificationsHeader";
    this.areaName = "Payroll";
    this.label = "محاسبه";
    this.setactions();
    if (this._VoucherKindInfo.VoucherKindId <= ElementGroup.Other) {
      this.actions.push({
        name: "ChangePayCurentYearMonth",
        disabled: false,
        displayName: "تغییر ماه سیستم",
        iconName: "icon-change_history-o",
        apiName: "MonthlySalaryCalculationInformation/ChangePayCurentYearMonth",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.samePermission,
      });
    }
    if (this._VoucherKindInfo.VoucherKindId === ElementGroup.RwrdPay) {
      this.actions.push({
        name: "RewardPaymentEffectWork",
        disabled: false,
        displayName: "اصلاح کارکرد موثر عیدی",
        iconName: "icon-Takenote",
        apiName: "RewardPaymentEffectWork",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.viewPermission,
      });
    }

    if (this._VoucherKindInfo.VoucherKindId === ElementGroup.VacationBuy) {
      this.actions.push({
        name: "VacationBuyInformation",
        disabled: false,
        displayName: "اصلاح مقدار بازخرید مرخصی",
        iconName: "icon-Takenote",
        apiName: "VacationBuyInformation",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.viewPermission,
      });
    }
    if (this._VoucherKindInfo.VoucherKindId === ElementGroup.EstablishmentTheReserveOfYearsOfService) {
      this.actions.push({
        name: "EstablishmentTheReserveOfYearsOfService",
        disabled: false,
        displayName: "استقرار ذخیره سنوات خدمت",
        iconName: "icon-Takenote",
        apiName: "EstablishmentTheReserveOfYearsOfService",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.viewPermission,
      });
    }
    this.cd.markForCheck();
    this.filterInfo = [];
    if (this._VoucherKindInfo.VoucherKindId <= ElementGroup.Other)
      this.filterInfo = [{ Name: "ElementGroupCode", Value: this._VoucherKindInfo.VoucherKindId, Operator: "lte" }];
    else this.filterInfo = [{ Name: "ElementGroupCode", Value: this._VoucherKindInfo.VoucherKindId, Operator: "eq" }];
    if (this.accountService.authService.getHrmPayCurentYearMonth()) {
      if (
        this.accountService.authService.getHrmPayCurentYearMonth().CurentYear &&
        this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth
      ) {
        this.filterInfo.push({ Name: "IssueYear", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear, Operator: "eq" });
        this.filterInfo.push({ Name: "IssueMonth", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth, Operator: "eq" });
        this.cd.markForCheck();
        setTimeout(() => this.grid.refreshData(), 200);
      }
    } else this.setHrmPayCurentYearMonth();
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: HRNotificationHeader,
    onRowsSelected: HRNotificationHeader[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    var filters: GridFilter[] = [];
    if (isAllSelected) {
      filters.push({ Filed: "IsAllSelected", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: isAllSelected, Logic: "and" });
    } else if (onRowsSelected && onRowsSelected.length > 0) {
      let PersonnelIds: number[] = [];
      onRowsSelected.forEach((x) => {
        PersonnelIds.push(x.HrmPersonnelId);
      });
      filters.push({ Filed: "PersonnelIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: PersonnelIds, Logic: "and" });
    } else if (onRowSelected) {
      let PersonnelIds: number[] = [];
      PersonnelIds.push(onRowSelected.HrmPersonnelId);
      filters.push({ Filed: "PersonnelIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: PersonnelIds, Logic: "and" });
    }

    ///  در اینجا باید سال و ماه محاسبه دریافت شود
    let IssueYearMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurrentYearMonth;
    if (!filters.some((x) => x.Filed === "ElementGroupCode")) {
      if (this._VoucherKindInfo.VoucherKindId <= ElementGroup.Other)
        filters.push({
          Filed: "ElementGroupCode",
          Operator: "lte",
          Type: "F",
          Skip: 0,
          Take: 20,
          Value: this._VoucherKindInfo.VoucherKindId,
          Logic: "and",
        });
      else
        filters.push({
          Filed: "ElementGroupCode",
          Operator: "eq",
          Type: "F",
          Skip: 0,
          Take: 20,
          Value: this._VoucherKindInfo.VoucherKindId,
          Logic: "and",
        });
    }

    filters.push({ Filed: "IssueYearMonth", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: IssueYearMonth, Logic: "and" });
    filters.push({
      Filed: "IssueYear",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear,
      Logic: "and",
    });
    filters.push({
      Filed: "IssueMonth",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth,
      Logic: "and",
    });

    ///محاسبه
    if (action.name === "Calculations") {
      if (!filters || filters.length <= 0) {
        this.sts.showDialog("هیچ کارمندی انتخاب نشده است.", "");
      }
      this.splashFormService.openDialog("", "در حال محاسبه");
      this.httpCommonService
        .create("MonthlySalaryCalculationInformation/Calculations", filters)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.splashFormService.closeLoading();
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            this.sts.showDialog("محاسبه با موفقیت انجام شد.", "");
          },
          (error) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog(`خطا در محاسبه ${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    }
    ///برگشت از محاسبه

    if (action.name === "DeCalculations") {
      if (!filters || filters.length <= 0) {
        this.sts.showDialog("هیچ کارمندی انتخاب نشده است.", "");
      }
      this.splashFormService.openDialog("", "در حال حذف محاسبه");
      this.httpCommonService
        .create("MonthlySalaryCalculationInformation/DeCalculations", filters)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.splashFormService.closeLoading();
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            this.sts.showDialog(" حذف محاسبه با موفقیت انجام شد.", "");
          },
          (error) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog(`خطا در حذف محاسبه${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    }
    ///تغییر ماه سیستم
    if (action.name === "ChangePayCurentYearMonth") {
      this.dialogService
        .open(
          ChangePayCurentYearMonthComponent,
          {
            areaName: this.areaName,
            apiName: this.apiName,
            label: "تغییر ماه سیستم حقوق",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          setTimeout(() => {
            this.grid?.clearFilter();
            this.ngOnInit();
          }, 500);
        });
    }
    ///هزینه عیدی
    if (action.name === "RewardPaymentEffectWork") {
      this.dialogService
        .open(
          RewardPaymentEffectWorkFormComponent,
          {
            areaName: this.areaName,
            apiName: this.apiName,
            label: "اصلاح کارکرد عیدی",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          this.ngOnInit();
        });
    }
    ///اصلاح مقدار بازخرید مرخصی
    if (action.name === "VacationBuyInformation") {
      this.dialogService
        .open(
          VacationBuyInformationFormComponent,
          {
            areaName: this.areaName,
            apiName: this.apiName,
            label: "اصلاح مقدار بازخرید مرخصی",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          this.ngOnInit();
        });
    }
    ///استقرار ذخیره سنوات خدمت
    if (action.name === "EstablishmentTheReserveOfYearsOfService") {
      this.dialogService
        .open(
          EstablishmentTheReserveOfYearsOfServiceFormComponent,
          {
            areaName: this.areaName,
            apiName: this.apiName,
            label: "استقرار ذخیره سنوات خدمت",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          this.ngOnInit();
        });
    }
  }
  setHrmPayCurentYearMonth() {
    this.dialogService
      .open(
        HrmPayCurentYearMonthComponent,
        {
          areaName: this.areaName,
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        this.ngOnInit();
      });
  }
  setactions() {
    this.actions = [
      {
        name: "Calculations",
        disabled: false,
        displayName: "محاسبه",
        iconName: "icon-calculate-F",
        apiName: "MonthlySalaryCalculationInformation/Calculations",
        areaName: "Payroll",
        permission: Permission.samePermission,
      },
      {
        name: "DeCalculations",
        disabled: false,
        displayName: "برگشت از محاسبه",
        iconName: "icon-delete-sweep-outline",
        apiName: "MonthlySalaryCalculationInformation/DeCalculations",
        areaName: "Payroll",
        permission: Permission.samePermission,
      },
    ];
  }
}
